import { render, staticRenderFns } from "./EmployeeStandByAndUrgentCallnfo.vue?vue&type=template&id=99ea8698&"
import script from "./EmployeeStandByAndUrgentCallnfo.vue?vue&type=script&lang=ts&"
export * from "./EmployeeStandByAndUrgentCallnfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports